"use client";

import { useEffect } from "react";
import { useAppContext } from "@/contexts/app-context";
import { useRecentlyViewedShops } from "@/contexts/recently-viewed-context";

interface ShopViewTrackerProps {
    shopId: string;
    shopName: string;
}

export function ShopViewTracker({ shopId, shopName }: ShopViewTrackerProps) {
    const { setSelectedShop } = useAppContext();
    const { addRecentShop } = useRecentlyViewedShops();

    useEffect(() => {
        setSelectedShop({ id: shopId, name: shopName });
        addRecentShop(shopId);

        return () => {
            setSelectedShop(null);
        };
    }, [shopId, shopName, setSelectedShop, addRecentShop]);

    return null;
}
